import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=754e0126&scoped=true"
import script from "./LostPassword.vue?vue&type=script&lang=js"
export * from "./LostPassword.vue?vue&type=script&lang=js"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=754e0126&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e0126",
  null
  
)

export default component.exports